"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Commissioner_Regular_ttf_1 = __importDefault(require("../assets/fonts/Commissioner-Regular.ttf"));
const md_1 = require("react-icons/md");
const deleteIcon = react_1.default.createElement(md_1.MdClose, null);
const commissioner = {
    fontFamily: 'Commissioner',
    fontStyle: 'normal',
    fontWeight: 400,
    fontDisplay: 'swap',
    src: `
    local('Commissioner-Regular'),
    url(${Commissioner_Regular_ttf_1.default}) format('truetype')
  `,
};
const colors = {
    primaryColor: '#C64D2F',
    secondaryColor: '#5f673b',
    primaryTextColor: '#3E3C3B',
    linkColor: '#1A5A96',
};
exports.theme = (0, styles_1.createMuiTheme)({
    /** Colors */
    palette: {
        primary: {
            light: '#d17058',
            main: colors.primaryColor,
            dark: '#8a3520',
        },
        secondary: {
            light: '#7f8562',
            main: colors.secondaryColor,
            dark: '#424829',
        },
        text: {
            primary: colors.primaryTextColor,
            secondary: '#575757',
        },
        common: {
            white: '#FFFFFF',
            black: '#000000',
        },
        background: {
            default: '#E6E6E6',
        },
        action: {
            hover: 'rgba(78,194,138,0.1)',
        },
        custom: {
            grey: '#DDDDDD',
        },
        error: { main: '#E02D41' },
        warning: { main: '#F8C51C' },
        info: { main: '#1471DE' },
        success: { main: '#43A047' },
    },
    /** Typography */
    typography: {
        fontFamily: '"Commissioner", sans-serif;',
        h1: {
            color: colors.secondaryColor,
            fontSize: '40px',
            lineHeight: '48px',
            letterSpacing: '0.7px',
            fontWeight: 'bold',
        },
        h2: {
            color: colors.primaryTextColor,
            fontSize: '32px',
            lineHeight: '40px',
            letterSpacing: '0.7px',
            fontWeight: 'bold',
        },
        h3: {
            color: colors.secondaryColor,
            fontSize: '27px',
            lineHeight: '32px',
            letterSpacing: '0.7px',
            fontWeight: 'bold',
        },
        h4: {
            color: colors.primaryColor,
            fontSize: '20px',
            lineHeight: '24px',
            letterSpacing: '0.7px',
            fontWeight: 600,
        },
        h5: {
            color: colors.primaryTextColor,
            fontSize: '18px',
            lineHeight: '20px',
            letterSpacing: '0.7px',
            fontWeight: 600,
        },
        subtitle1: {
            color: colors.primaryTextColor,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
            fontWeight: 600,
        },
        subtitle2: {
            color: colors.primaryTextColor,
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: 0,
            fontWeight: 600,
        },
        body1: {
            color: colors.primaryTextColor,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        body2: {
            color: colors.primaryTextColor,
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: 0,
        },
        caption: {
            color: colors.primaryTextColor,
            fontSize: '20px',
            lineHeight: '32px',
            letterSpacing: 0,
        },
        overline: {
            color: colors.primaryTextColor,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        button: {
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: 0,
            textTransform: 'capitalize',
        },
    },
    props: {
        MuiChip: {
            deleteIcon: deleteIcon,
            size: 'small',
        },
    },
    /** Overrides */
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [commissioner],
                '#root': {
                    display: 'flex',
                    flexDirection: 'column',
                },
                ul: {
                    padding: '0 0 0 1rem',
                    margin: 0,
                },
                body: {
                    lineHeight: 1.5,
                },
            },
        },
        MuiAppBar: {
            root: {
                backgroundColor: '#fff',
            },
        },
        MuiContainer: {
            root: {
                '@media (max-width:750px)': {
                    paddingLeft: '10px',
                    paddingRight: '10px',
                },
            },
        },
        MuiButton: {
            root: {
                fontSize: '14px',
                lineHeight: '16px',
                letterSpacing: 0,
                textTransform: 'capitalize',
                textAlign: 'center',
                borderRadius: '4px',
                '&:disabled': {
                    backgroundColor: '#A09FA8',
                    color: '#747378',
                },
                '&:active': {
                    boxShadow: 'none',
                },
                '&:focus': {
                    outline: 'none',
                },
            },
            containedPrimary: {
                color: '#fff',
                fontWeight: 600,
                backgroundColor: colors.primaryColor,
                lineHeight: '30px',
                minWidth: '160px',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: `${colors.primaryColor}AA`,
                    boxShadow: 'none',
                },
                '&:disabled': {
                    backgroundColor: `${colors.primaryTextColor}32`,
                },
            },
            containedSecondary: {
                color: '#fff',
                fontWeight: 600,
                backgroundColor: colors.primaryTextColor,
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: '#34495E',
                    boxShadow: 'none',
                },
                '&:disabled': {
                    backgroundColor: `${colors.primaryTextColor}32`,
                },
            },
            outlinedPrimary: {
                border: '1px solid #34495E',
                backgroundColor: '#fff',
                color: colors.primaryTextColor,
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: `${colors.primaryTextColor}16`,
                    border: `1px solid ${colors.primaryTextColor}16`,
                    boxShadow: 'none',
                },
                '&:disabled': {
                    backgroundColor: `${colors.primaryTextColor}32`,
                    border: '1px solid #DDDDDD',
                    color: '#858585aa',
                },
            },
            outlinedSecondary: {
                border: '1px solid #34495E',
                backgroundColor: '#F8F4F4',
                color: colors.primaryTextColor,
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: `${colors.primaryTextColor}16`,
                    border: `1px solid ${colors.primaryTextColor}16`,
                    boxShadow: 'none',
                },
                '&:disabled': {
                    backgroundColor: `${colors.primaryTextColor}32`,
                    border: '1px solid #DDDDDD',
                    color: '#858585aa',
                },
            },
            sizeSmall: {
                fontSize: '11px',
                lineHeight: '16px',
                padding: '4px',
                margin: '5px',
            },
            sizeLarge: {
                fontSize: '16px',
                lineHeight: '24px',
                fontWeight: 600,
            },
        },
        MuiIconButton: {
            root: {
                padding: '5px',
                boxShadow: 'none',
                '&:focus': {
                    outline: 'none',
                },
            },
        },
        MuiMenu: {
            list: {
                minWidth: 175,
            },
        },
        MuiMenuItem: {
            root: {
                fontSize: 16,
            },
        },
        MuiListItemText: {
            primary: {
                fontSize: '14px !important',
            },
        },
        MuiLink: {
            root: {
                color: colors.linkColor,
                width: 'fit-content',
                fontWeight: 'bold',
                '&:hover': {
                    textDecoration: 'underline',
                    cursor: 'pointer',
                },
            },
        },
        MuiTableCell: {
            root: {
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
            },
        },
        MuiTableSortLabel: {
            root: {},
            icon: {
                display: 'none',
            },
        },
        MuiInputBase: {
            root: {
                border: '1px solid #DDDDDD',
                borderRadius: '4px',
            },
            input: {
                backgroundColor: '#fff',
                '&:disabled': {
                    backgroundColor: '#EEEEEE',
                },
            },
            multiline: {
                paddingTop: '0',
                paddingBottom: '0',
            },
            inputMultiline: {
                paddingLeft: '1rem',
                paddingRight: '1rem',
                '&:first-child': {
                    paddingTop: '1rem',
                    paddingBottom: '1rem',
                },
            },
        },
        MuiFilledInput: {
            root: {
                padding: '0 !important',
                backgroundColor: '#fff',
                '&:hover': {
                    backgroundColor: '#fff',
                },
                boxShadow: 'none',
            },
            input: {
                padding: '16px 12px 17px',
                borderRadius: '4px',
                backgroundColor: '#fff',
            },
            underline: {
                '&::before': {
                    borderBottom: 'none',
                    borderBottomStyle: 'none !important',
                },
            },
        },
        MuiOutlinedInput: {
            input: {
                padding: '12.5px 14px',
            },
        },
        MuiSelect: {
            root: {
                padding: '16px 12px 17px',
                backgroundColor: '#fff',
                border: '0 transparent',
            },
        },
        MuiCard: {
            root: {
                borderRadius: '4px',
                boxShadow: '0 0 10px 0 rgba(16,26,46,0.07)',
                padding: '0',
            },
        },
        MuiCardContent: {
            root: {
                padding: '0',
            },
        },
        MuiChip: {
            root: {
                lineHeight: '14px',
                borderRadius: 0,
                fontSize: '0.75rem',
                border: `1px solid #DDDDDD`,
                backgroundColor: '#FFFFFF',
            },
        },
        MuiTooltip: {
            tooltip: {
                backgroundColor: colors.primaryTextColor,
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: '18px',
                padding: '20px',
            },
            arrow: {
                color: colors.primaryTextColor,
            },
        },
        MuiFormLabel: {
            root: {
                fontSize: '14px',
            },
        },
    },
});
